export const ADD_NEW_VALUE = "__add_new__";

/**
 * Handle select change for school_year or category dropdowns.
 * Returns { openDialog: true } if the sentinel value was selected,
 * otherwise returns the selected value for the given type.
 */
export function handleSelectValue(value: string): { openDialog: true } | { value: string } {
  if (value === ADD_NEW_VALUE) return { openDialog: true };
  return { value };
}

/**
 * Process a dialog submission: trim, dedup, sort, and return the updated list + selected value.
 * Returns null if the trimmed value is empty.
 */
export function processDialogSubmit(
  dialogValue: string,
  existingItems: string[],
): { updatedList: string[]; selectedValue: string } | null {
  const trimmed = dialogValue.trim();
  if (!trimmed) return null;

  const updatedList = existingItems.includes(trimmed)
    ? existingItems
    : [...existingItems, trimmed].sort((a, b) => a.localeCompare(b));

  return { updatedList, selectedValue: trimmed };
}

/**
 * Toggle a group ID in/out of a selection array.
 */
export function toggleGroupSelection(selected: string[], groupId: string): string[] {
  return selected.includes(groupId)
    ? selected.filter((id) => id !== groupId)
    : [...selected, groupId];
}
